export const KEYWORD_GROUPS = [
  {
    title: "Lab-grown diamonds",
    items: [
      "lab grown diamonds", "lab created diamonds", "lab made diamonds", "man made diamonds", "synthetic diamonds",
      "cultured diamonds", "cvd diamonds", "hpht diamonds", "cvd diamond price", "hpht diamond price",
      "lab grown diamond price", "lab grown diamond price per carat", "lab grown diamond cost", "lab grown diamond rate today",
      "1 carat lab grown diamond price", "2 carat lab grown diamond price", "0.5 carat lab grown diamond price",
      "lab grown diamond price in india", "lab grown diamond price list", "cvd diamond price per carat india",
      "type iia lab grown diamond", "lab grown diamond manufacturer", "lab grown diamond supplier", "lab grown diamond dealer",
      "lab grown diamond company", "lab grown diamond exporter", "lab grown diamond india", "lab grown diamond online",
      "buy lab grown diamonds", "buy lab grown diamonds online", "lab grown diamond shop near me", "lab grown diamond store",
    ],
  },
  {
    title: "B2B & wholesale",
    items: [
      "wholesale lab grown diamonds", "lab grown diamonds wholesale price", "cvd diamonds wholesale", "hpht diamonds wholesale",
      "wholesale loose diamonds", "diamond wholesaler india", "diamond wholesaler hyderabad", "b2b lab grown diamonds",
      "b2b diamond supplier", "b2b diamond trading", "bulk lab grown diamonds", "bulk diamond purchase", "diamond parcel for sale",
      "diamond parcel price", "melee diamond parcel", "melee diamonds wholesale", "loose melee diamonds", "star melee diamonds",
      "lab grown melee diamonds", "cvd melee diamonds", "diamond lots for jewellers", "diamond supplier for jewellers",
      "diamonds for jewellery manufacturers", "diamond sourcing india", "diamond trader hyderabad", "diamond merchant hyderabad",
      "gst registered diamond dealer", "diamond dealer with gst bill", "certified diamond wholesaler", "igi certified diamonds wholesale",
      "loose diamonds for jewellery making", "diamond stones for making jewellery", "polished diamonds wholesale", "polished lab grown diamonds",
      "lab grown diamond rough", "cvd rough diamonds", "diamond price per carat wholesale", "diamond rate per carat",
      "diamond per carat price india", "carat wise diamond price", "sieve size diamonds", "calibrated diamonds", "calibrated melee",
      "diamond dealer for retailers", "diamond stock for jewellers",
      "loose lab grown diamonds", "loose cvd diamonds", "loose diamonds", "loose diamonds for sale", "loose diamonds online",
      "loose diamonds price", "loose diamond dealer", "loose diamond wholesaler", "loose diamonds hyderabad", "loose diamonds near me",
    ],
  },
  {
    title: "Hyderabad & local",
    items: [
      "lab grown diamonds hyderabad", "cvd diamonds hyderabad", "diamond dealer hyderabad",
      "diamond shop hyderabad", "diamond store abids", "diamonds abids hyderabad", "jewellers abids", "abids jewellery market",
      "diamond wholesaler abids", "lab grown diamond shop near abids", "diamond market hyderabad", "diamond price hyderabad",
      "diamond price today hyderabad", "best diamond dealer hyderabad", "trusted diamond dealer hyderabad", "diamond merchant telangana",
      "lab grown diamonds telangana", "lab grown diamonds secunderabad", "diamond shop near me",
      "lab grown diamonds near me", "cvd diamond dealer near me", "diamond jeweller near me", "lab grown diamond store hyderabad",
      "solitaire diamond hyderabad", "solitaire price hyderabad", "diamond ring hyderabad", "diamond jewellery hyderabad",
      "lab grown diamond jewellery hyderabad", "chirag ali lane jewellers", "mahalakshmi gem jewellers abids", "padmavati gem and jewels",
      "padmavati gem & jewelss", "padmavati diamonds hyderabad",
    ],
  },
  {
    title: "Shapes",
    items: [
      "round brilliant lab grown diamond", "round diamond price", "round cut diamond", "oval lab grown diamond", "oval diamond price",
      "oval cut diamond", "emerald cut lab grown diamond", "emerald cut diamond price", "princess cut lab grown diamond",
      "princess cut diamond price", "cushion cut lab grown diamond", "cushion cut diamond price", "pear shape lab grown diamond",
      "pear cut diamond price", "marquise lab grown diamond", "marquise cut diamond", "radiant cut lab grown diamond",
      "radiant cut diamond price", "asscher cut lab grown diamond", "asscher cut diamond", "heart shape lab grown diamond",
      "heart cut diamond price", "fancy shape lab grown diamonds", "fancy cut diamonds wholesale", "diamond shapes chart",
      "diamond shapes and names", "types of diamond cuts", "best diamond shape for ring", "diamond shape price difference",
      "elongated cushion lab grown", "crushed ice cushion diamond", "step cut diamonds", "brilliant cut diamonds",
      "round melee diamonds", "baguette lab grown diamonds", "tapered baguette diamonds", "diamond shapes size chart mm",
      "oval vs round lab grown diamond", "emerald vs asscher cut", "pear vs marquise diamond",
    ],
  },
  {
    title: "Melee, sieve & mm sizes",
    items: [
      "1mm diamonds", "1.2mm diamonds", "1.5mm diamonds", "1.7mm diamonds", "2mm diamonds", "2.5mm diamonds", "3mm diamonds",
      "3.5mm diamonds", "4mm diamonds", "5mm diamond price", "6.5mm diamond carat", "diamond mm to carat chart",
      "diamond sieve size chart", "sieve size to mm", "diamond sieve plates", "-2 sieve diamonds", "+2 -4 sieve diamonds",
      "+4 -6.5 sieve diamonds", "+6.5 -11 sieve diamonds", "+11 -15 sieve diamonds", "+15 sieve diamonds", "pointer diamonds",
      "10 pointer diamond price", "20 pointer diamond price", "30 pointer diamond price", "50 pointer diamond price",
      "small diamonds for jewellery", "tiny diamonds for pave", "pave setting diamonds", "diamond pieces per carat",
      "melee diamond price per carat", "cvd melee price", "diamond parcel carat weight", "single cut melee diamonds",
      "full cut melee diamonds",
    ],
  },
  {
    title: "Clarity, colour & cut",
    items: [
      "diamond clarity chart", "diamond clarity scale", "fl clarity diamond", "if clarity diamond", "vvs1 lab grown diamond",
      "vvs2 lab grown diamond", "vs1 lab grown diamond", "vs2 lab grown diamond", "si1 lab grown diamond", "si2 lab grown diamond",
      "i1 clarity diamond", "vvs diamond price", "vs diamond price", "si diamond price", "eye clean diamond", "vvs vs vs diamond",
      "vs1 vs vs2 difference", "diamond colour grade chart", "d colour lab grown diamond", "e colour lab grown diamond",
      "f colour lab grown diamond", "g colour lab grown diamond", "h colour diamond price", "def colour diamonds",
      "def vvs lab grown diamonds", "ef vvs vs diamonds", "gh vs si diamonds", "excellent cut lab grown diamond",
      "ideal cut lab grown diamond", "triple excellent diamond", "3ex lab grown diamond", "diamond 4cs explained",
      "what matters when buying a diamond", "how to choose diamond clarity", "how to choose diamond colour",
    ],
  },
  {
    title: "Certification & trust",
    items: [
      "igi certified lab grown diamonds", "igi certified diamonds price", "gia certified lab grown diamonds", "gia lab grown report",
      "igi vs gia lab grown", "certified loose diamonds", "certified lab grown diamonds india", "sgl certified diamonds",
      "diamond certificate check", "igi certificate verification", "laser inscribed lab grown diamond", "diamond grading report",
      "hallmark diamond jewellery", "bis hallmark diamond jewellery", "conflict free diamonds", "ethical diamonds india",
      "sustainable diamonds", "eco friendly diamonds", "real lab grown diamonds", "are lab grown diamonds real",
      "lab grown diamond test", "diamond tester lab grown", "genuine cvd diamonds", "trusted lab grown diamond seller",
      "gst invoice diamonds",
    ],
  },
  {
    title: "Buying & offers",
    items: [
      "diamond price today", "diamond price per carat india", "diamond rate today india", "1 carat diamond price india",
      "2 carat diamond price india", "half carat diamond price", "solitaire price per carat", "solitaire diamond price",
      "lab grown solitaire price", "cheap lab grown diamonds", "affordable lab grown diamonds", "best price lab grown diamonds",
      "lab grown diamond discount", "lab grown diamond offers", "lab grown diamond deals", "buy diamonds online india",
      "buy loose diamonds india", "buy cvd diamond online", "order diamonds on whatsapp", "diamond enquiry whatsapp",
      "diamond price on whatsapp", "diamond quotation", "diamond price calculator", "lab grown diamond price calculator",
      "diamond investment india", "lab grown diamond resale value", "lab grown diamond buyback", "lab grown diamond exchange",
      "lab grown diamond emi", "diamond gift under 50000", "diamond ring under 1 lakh", "lab grown diamond ring price",
      "lab grown diamond earrings price", "lab grown diamond pendant price", "lab grown diamond bracelet price",
      "lab grown diamond necklace price", "lab grown diamond bangles price", "lab grown diamond nose pin price",
      "lab grown diamond mangalsutra price", "lab grown diamond studs price",
    ],
  },
  {
    title: "Jewellery (B2C)",
    items: [
      "lab grown diamond jewellery", "lab grown diamond rings", "lab grown diamond engagement ring", "lab grown diamond wedding ring",
      "lab grown solitaire ring", "lab grown diamond earrings", "lab grown diamond studs", "lab grown diamond pendant",
      "lab grown diamond necklace", "lab grown diamond bracelet", "lab grown tennis bracelet", "lab grown diamond bangles",
      "lab grown diamond nose pin", "lab grown diamond mangalsutra", "lab grown diamond eternity band", "lab grown halo ring",
      "custom lab grown diamond ring", "custom diamond jewellery hyderabad", "made to order diamond jewellery", "bespoke diamond ring india",
      "diamond ring design", "solitaire ring designs", "engagement ring hyderabad", "bridal diamond jewellery",
      "diamond jewellery for wedding", "diamond gift for wife", "diamond gift for anniversary", "diamond jewellery gift",
      "men's lab grown diamond ring", "lab grown diamond kada", "lab grown diamond for men", "diamond jewellery in gold",
      "18k gold lab grown diamond ring", "14k gold lab grown diamond ring", "platinum lab grown diamond ring",
    ],
  },
  {
    title: "Compare & learn",
    items: [
      "lab grown vs natural diamond", "lab grown vs natural diamond price", "lab grown vs mined diamond", "lab grown vs moissanite",
      "cvd vs hpht diamond", "cvd vs natural diamond", "cvd diamond vs real diamond", "difference between cvd and hpht",
      "is lab grown diamond worth it", "why buy lab grown diamond", "lab grown diamond pros and cons", "lab grown diamond durability",
      "lab grown diamond hardness", "how lab grown diamonds are made", "lab grown diamond process", "lab grown diamond guide",
      "diamond buying guide india", "diamond size chart", "carat weight vs size", "how to buy loose diamonds",
    ],
  },
];

export const ALL_KEYWORDS = KEYWORD_GROUPS.flatMap((g) => g.items);

export const PAGE_KEYWORDS = {
  "/": ["Lab-grown diamonds", "Hyderabad & local"],
  "/browse": ["Shapes", "Melee, sieve & mm sizes", "Clarity, colour & cut"],
  "/bulk-order": ["B2B & wholesale", "Certification & trust"],
  "/about": ["Compare & learn", "Jewellery (B2C)"],
  "/enquiry": ["Buying & offers"],
};
